export default "__VITE_ASSET__B4T7Y0j8__"